import React from 'react'
import logo from '../img/icon.jpg';

const Present = () => {
    return (
        <div className='present'>

            {/* <div className='present2' style={{ display: 'flex' }}>

                <div className='logs'>
                <img src={logo} width="70" height="55" />

                </div>
                <div className='logs'>
                    <h1 style={{ color: '#5e4e6d' }}>MOM'S EXPRESS </h1>
                    <h1 className='disc'>BIRTH & BEYOND!</h1>
                </div>
            </div> */}
            <div className='present2  '>

                <h1 >Dr. Mansi Shukul</h1>
                 <p> <a href='Tel:+91 8838291513' style={{textDecoration:"none", color: 'black'}}><i class="fa fa-phone"></i> +91 8838291513</a></p>
               
            </div>

            <div className='icons'>
                <i class="fa fa-phone"></i>
            </div>

            <div className='present2 '>

                <h1> Dr. Garima Gupta</h1>
                 <p> <a href='Tel:+91 9140458191' style={{textDecoration:"none" , color: 'black'}}><i class="fa fa-phone"></i> +91 9140458191</a></p>
               
            </div>

            <div className='icons'>
                <i class="fa fa-map-marker"></i>
            </div>

            <div className='present2 '>
                <h1>Address </h1>
                <p style={{marginLeft:'30px', color: 'black'}}> 1/1, Vineet Khand , Opposite Jaipuria School, Gomtinagar, Lucknow, Uttar Pradesh -226010</p>

            </div>
        </div>
    )
}

export default Present